import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useStyles } from "./styles";

function a11yProps(index) {
   return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
   };
}

const routes = [
   {
      index: 0,
      path: "/dashboard",
   },
   {
      index: 1,
      path: "/wallet",
   },
   {
      index: 2,
      path: "/opportunities",
   },
   {
      index: 3,
      path: "/account",
   },
];

const MobileMenus = () => {
   const navigate = useNavigate();
   const { pathname } = useLocation();
   const classes = useStyles();
   const [tab, setTab] = useState(0);

   const handleChangeTab = (event, index) => {
      setTab(index);
      navigate(routes[index].path);
   };

   useEffect(() => {
      if (pathname) {
         let check = routes.find((f) => f.path === pathname);
         if (check) {
            setTab(check.index);
         }
      }
   }, []);

   return (
      <Box className={classes.mobile_menus}>
         <Tabs
            value={tab}
            onChange={handleChangeTab}
            scrollButtons="auto"
            variant="fullWidth"
            centered
            className={classes.tabs}
            sx={{
               "& .MuiTabs-indicator": {
                  display: "none",
               },
               "& .Mui-selected": {
                  color: "#4B5EFF !important",
                  fontWeight: 700,
               },
            }}
         >
            <Tab
               className={classes.tab_item}
               icon={
                  <svg
                     width="26"
                     height="24"
                     viewBox="0 0 26 24"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.34488 9.2H7.54796C8.3298 9.2 8.96949 9.83 8.96949 10.6V17.6C8.96949 18.37 8.3298 19 7.54796 19H7.34488C6.56303 19 5.92334 18.37 5.92334 17.6V10.6C5.92334 9.83 6.56303 9.2 7.34488 9.2ZM13.031 5C13.8129 5 14.4526 5.63 14.4526 6.4V17.6C14.4526 18.37 13.8129 19 13.031 19C12.2492 19 11.6095 18.37 11.6095 17.6V6.4C11.6095 5.63 12.2492 5 13.031 5ZM18.7172 13C19.499 13 20.1387 13.63 20.1387 14.4V17.6C20.1387 18.37 19.499 19 18.7172 19C17.9353 19 17.2956 18.37 17.2956 17.6V14.4C17.2956 13.63 17.9353 13 18.7172 13Z"
                        fill={tab === 0 ? "#4B5EFF" : "#3A3F63"}
                     />
                  </svg>
               }
               label="Staking"
               {...a11yProps(0)}
            />
            <Tab
               className={classes.tab_item}
               icon={
                  <svg
                     width="23"
                     height="21"
                     viewBox="0 0 23 21"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.57666 6.125C2.57666 4.67775 3.77253 3.5 5.24204 3.5H17.6805C19.15 3.5 20.3459 4.67775 20.3459 6.125V14.875C20.3459 16.3223 19.15 17.5 17.6805 17.5H5.24204C3.77253 17.5 2.57666 16.3223 2.57666 14.875V6.125ZM17.8537 5.71024C18.0635 5.57525 17.9679 5.25 17.7184 5.25H5.20411C4.95465 5.25 4.85905 5.57525 5.06883 5.71024L10.9587 9.50015C11.2704 9.66662 11.6522 9.66662 11.9639 9.50015L17.8537 5.71024Z"
                        // fill="#3A3F63"
                        fill={tab === 1 ? "#4B5EFF" : "#3A3F63"}
                     />
                     <mask
                        id="mask0_384_1651"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="2"
                        y="3"
                        width="19"
                        height="15"
                     >
                        <path
                           fill-rule="evenodd"
                           clip-rule="evenodd"
                           d="M2.57666 6.125C2.57666 4.67775 3.77253 3.5 5.24204 3.5H17.6805C19.15 3.5 20.3459 4.67775 20.3459 6.125V14.875C20.3459 16.3223 19.15 17.5 17.6805 17.5H5.24204C3.77253 17.5 2.57666 16.3223 2.57666 14.875V6.125ZM17.8537 5.71024C18.0635 5.57525 17.9679 5.25 17.7184 5.25H5.20411C4.95465 5.25 4.85905 5.57525 5.06883 5.71024L10.9587 9.50015C11.2704 9.66662 11.6522 9.66662 11.9639 9.50015L17.8537 5.71024Z"
                           //  fill="white"
                           fill={tab === 1 ? "#4B5EFF" : "#fff"}
                        />
                     </mask>
                     <g mask="url(#mask0_384_1651)"></g>
                  </svg>
               }
               label="Wallets"
               {...a11yProps(1)}
            />
            <Tab
               className={classes.tab_item}
               icon={
                  <svg
                     width="26"
                     height="24"
                     viewBox="0 0 26 24"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M22.2466 5.31138C22.2466 6.90734 20.0536 7.62186 17.8805 7.62186C15.7065 7.62186 13.5134 6.90734 13.5134 5.31138C13.5134 3.71453 15.7065 3 17.8805 3C20.0536 3 22.2466 3.71453 22.2466 5.31138ZM22.1023 8.95203C21.4306 9.88489 19.8098 10.4641 17.8708 10.4641C15.9309 10.4641 14.3101 9.88489 13.6385 8.95203C13.4061 8.62815 13.4803 8.17796 13.8039 7.9452C14.1293 7.71244 14.5804 7.78642 14.8127 8.1103C15.1309 8.55147 16.3106 9.0206 17.8708 9.0206C19.4311 9.0206 20.6098 8.55147 20.928 8.1103C21.1604 7.78642 21.6114 7.71244 21.9369 7.9452C22.2605 8.17796 22.3346 8.62815 22.1023 8.95203ZM22.1023 11.5863C21.4306 12.5192 19.8098 13.0984 17.8708 13.0984C15.9309 13.0984 14.3101 12.5192 13.6385 11.5863C13.4061 11.2624 13.4803 10.8122 13.8039 10.5795C14.1293 10.3458 14.5804 10.4207 14.8127 10.7446C15.1309 11.1857 16.3106 11.6549 17.8708 11.6549C19.4311 11.6549 20.6098 11.1857 20.928 10.7446C21.1604 10.4207 21.6114 10.3458 21.9369 10.5795C22.2605 10.8122 22.3346 11.2624 22.1023 11.5863ZM17.8708 15.7326C19.8098 15.7326 21.4306 15.1534 22.1023 14.2206C22.3346 13.8967 22.2605 13.4465 21.9369 13.2137C21.6114 12.9801 21.1604 13.055 20.928 13.3788C20.6098 13.82 19.4311 14.2891 17.8708 14.2891C16.3106 14.2891 15.1309 13.82 14.8127 13.3788C14.5804 13.055 14.1293 12.9801 13.8039 13.2137C13.4803 13.4465 13.4061 13.8967 13.6385 14.2206C14.3101 15.1534 15.9309 15.7326 17.8708 15.7326ZM17.8706 16.9231C19.4309 16.9231 20.6097 16.454 20.9279 16.0128C21.1602 15.6899 21.614 15.615 21.9367 15.8477C22.2621 16.0805 22.3353 16.5316 22.1021 16.8555C21.4305 17.7874 19.8096 18.3657 17.8706 18.3657C15.9325 18.3657 14.3108 17.7874 13.6392 16.8555C13.406 16.5316 13.4792 16.0805 13.8037 15.8477C14.1273 15.615 14.5811 15.6899 14.8125 16.0128C15.1307 16.454 16.3113 16.9231 17.8706 16.9231ZM20.9279 18.6471C20.6097 19.0883 19.4309 19.5574 17.8706 19.5574C16.3113 19.5574 15.1307 19.0883 14.8125 18.6471C14.5811 18.3232 14.1273 18.2502 13.8037 18.482C13.4792 18.7148 13.406 19.1659 13.6392 19.4898C14.3108 20.4217 15.9325 21 17.8706 21C19.8096 21 21.4305 20.4217 22.1021 19.4898C22.3353 19.1659 22.2621 18.7148 21.9367 18.482C21.614 18.2502 21.1602 18.3232 20.9279 18.6471ZM3.96974 10.5799C3.96974 8.98307 6.16366 8.26764 8.33679 8.26764C10.5099 8.26764 12.7038 8.98307 12.7038 10.5799C12.7038 12.1759 10.5099 12.8904 8.33679 12.8904C6.16366 12.8904 3.96974 12.1759 3.96974 10.5799ZM8.33679 15.7326C10.2767 15.7326 11.8975 15.1534 12.5692 14.2206C12.8015 13.8967 12.7273 13.4465 12.4037 13.2137C12.0783 12.9801 11.6272 13.055 11.3949 13.3788C11.0767 13.82 9.89703 14.2891 8.33679 14.2891C6.77655 14.2891 5.59778 13.82 5.27958 13.3788C5.04726 13.055 4.59618 12.9801 4.27075 13.2137C3.94713 13.4465 3.87301 13.8967 4.10533 14.2206C4.77697 15.1534 6.39778 15.7326 8.33679 15.7326ZM8.33661 16.9231C9.89686 16.9231 11.0765 16.454 11.3947 16.0128C11.627 15.6899 12.0808 15.615 12.4036 15.8477C12.729 16.0805 12.8022 16.5316 12.569 16.8555C11.8973 17.7874 10.2756 18.3657 8.33661 18.3657C6.39851 18.3657 4.7777 17.7874 4.10606 16.8555C3.87283 16.5316 3.94605 16.0805 4.27058 15.8477C4.5942 15.615 5.04799 15.6899 5.2794 16.0128C5.5976 16.454 6.77727 16.9231 8.33661 16.9231ZM11.3947 18.6471C11.0765 19.0883 9.89686 19.5574 8.33661 19.5574C6.77727 19.5574 5.5976 19.0883 5.2794 18.6471C5.04799 18.3232 4.5942 18.2502 4.27058 18.482C3.94605 18.7148 3.87283 19.1659 4.10606 19.4898C4.7777 20.4217 6.39851 21 8.33661 21C10.2756 21 11.8973 20.4217 12.569 19.4898C12.8022 19.1659 12.729 18.7148 12.4036 18.482C12.0808 18.2502 11.627 18.3232 11.3947 18.6471Z"
                        fill={tab === 2 ? "#4B5EFF" : "#3A3F63"}
                     />
                  </svg>
               }
               label="Opportunities"
               {...a11yProps(2)}
               sx={{
                  "& .Mui-selected svg": {
                     color: "red",
                  },
               }}
            />
            <Tab
               className={classes.tab_item}
               icon={
                  <svg
                     width="25"
                     height="24"
                     viewBox="0 0 25 24"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.27689 12C7.03376 12 5.21535 10.2091 5.21535 8C5.21535 5.79086 7.03376 4 9.27689 4C11.52 4 13.3384 5.79086 13.3384 8C13.3384 10.2091 11.52 12 9.27689 12ZM9.27689 14C11.988 14 17.4 15.34 17.4 18V19C17.4 19.55 16.943 20 16.3846 20H2.16919C1.61073 20 1.15381 19.55 1.15381 19V18C1.15381 15.34 6.56581 14 9.27689 14ZM18.6692 7.5C18.6692 7.22386 18.8965 7 19.1769 7H19.6846C19.965 7 20.1923 7.22386 20.1923 7.5L20.2532 7.92017C20.3078 8.29637 20.7517 8.47747 21.0604 8.24946L21.4052 7.9948C21.6035 7.79953 21.9249 7.79953 22.1232 7.9948L22.4822 8.34835C22.6804 8.54361 22.6804 8.8602 22.4822 9.05546L22.2236 9.395C21.9921 9.69902 22.176 10.1362 22.5579 10.19L22.9846 10.25C23.265 10.25 23.4923 10.4739 23.4923 10.75V11.25C23.4923 11.5261 23.265 11.75 22.9846 11.75L22.5579 11.81C22.176 11.8638 21.9921 12.301 22.2236 12.605L22.4822 12.9445C22.6804 13.1398 22.6804 13.4564 22.4822 13.6516L22.1232 14.0052C21.9249 14.2005 21.6035 14.2005 21.4052 14.0052L21.0604 13.7505C20.7517 13.5225 20.3078 13.7036 20.2532 14.0798L20.1923 14.5C20.1923 14.7761 19.965 15 19.6846 15H19.1769C18.8965 15 18.6692 14.7761 18.6692 14.5L18.6082 14.0798C18.5537 13.7036 18.1097 13.5225 17.801 13.7505L17.4563 14.0052C17.258 14.2005 16.9366 14.2005 16.7383 14.0052L16.3793 13.6516C16.181 13.4564 16.181 13.1398 16.3793 12.9445L16.6379 12.605C16.8694 12.301 16.6855 11.8638 16.3035 11.81L15.8769 11.75C15.5965 11.75 15.3692 11.5261 15.3692 11.25V10.75C15.3692 10.4739 15.5965 10.25 15.8769 10.25L16.3035 10.19C16.6855 10.1362 16.8694 9.69902 16.6379 9.395L16.3793 9.05546C16.181 8.8602 16.181 8.54361 16.3793 8.34835L16.7383 7.9948C16.9366 7.79953 17.258 7.79953 17.4563 7.9948L17.801 8.24946C18.1097 8.47747 18.5537 8.29637 18.6082 7.92017L18.6692 7.5ZM20.4461 11C20.4461 11.5523 19.9915 12 19.4307 12C18.87 12 18.4153 11.5523 18.4153 11C18.4153 10.4477 18.87 10 19.4307 10C19.9915 10 20.4461 10.4477 20.4461 11Z"
                        // fill="#3A3F63"
                        fill={tab === 3 ? "#4B5EFF" : "#3A3F63"}
                     />
                  </svg>
               }
               label="Account"
               {...a11yProps(3)}
            />
         </Tabs>
      </Box>
   );
};

export default MobileMenus;
